import {
  SUB_AGENT_LIST_REQUEST,
  SUB_AGENT_LIST_SUCCESS,
  SUB_AGENT_LIST_FAIL,
  SUB_AGENT_CREATE_REQUEST,
  SUB_AGENT_CREATE_SUCCESS,
  SUB_AGENT_CREATE_FAIL,
  SUB_AGENT_GET_REQUEST,
  SUB_AGENT_GET_SUCCESS,
  SUB_AGENT_GET_FAIL,
  SUB_AGENT_UPDATE_SUCCESS,
  SUB_AGENT_UPDATE_REQUEST,
  SUB_AGENT_UPDATE_FAIL,
  SUB_AGENT_DELETE_REQUEST,
  SUB_AGENT_DELETE_SUCCESS,
  SUB_AGENT_DELETE_FAIL,
} from "../constants/subagentConstants";
import {
  SUB_AGENT_VERIFY_STATUS_REQUEST,
  SUB_AGENT_VERIFY_STATUS_SUCCESS,
  SUB_AGENT_VERIFY_STATUS_FAIL,
  SUB_AGENT_VERIFY_ACTION_REQUEST,
  SUB_AGENT_VERIFY_ACTION_SUCCESS,
  SUB_AGENT_VERIFY_ACTION_FAIL,
} from "../constants/subagentConstants";
import api from "../core/api";

// Get verification status
export const getSubAgentVerifyStatus = (subAgentId) => async (dispatch) => {
  try {
    dispatch({
      type: SUB_AGENT_VERIFY_STATUS_REQUEST,
    });

    const { data } = await api.get("/subagent/get-verify-status/" + subAgentId);

    dispatch({
      type: SUB_AGENT_VERIFY_STATUS_SUCCESS,
      payload: data?.Result,
    });
  } catch (error) {
    dispatch({
      type: SUB_AGENT_VERIFY_STATUS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Verify / Reject subagent
export const verifySubAgentStatus = (body) => async (dispatch) => {
  try {
    dispatch({
      type: SUB_AGENT_VERIFY_ACTION_REQUEST,
    });

    const { data } = await api.post("/subagent/approve-company", body);

    dispatch({
      type: SUB_AGENT_VERIFY_ACTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SUB_AGENT_VERIFY_ACTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createSubAgent = (parm) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUB_AGENT_CREATE_REQUEST });
    const { data } = await api.post("/subagent", parm);

    var dt = data.Result;
    if (dt.includes("Error")) {
      dispatch({
        type: SUB_AGENT_CREATE_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: SUB_AGENT_CREATE_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: SUB_AGENT_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listSubAgents = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SUB_AGENT_LIST_REQUEST });
    const { data } = await api.get("/subagent");

    var dt = data.Result;
    if (typeof dt == "string") {
      dispatch({
        type: SUB_AGENT_LIST_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: SUB_AGENT_LIST_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: SUB_AGENT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getSubAgents = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUB_AGENT_GET_REQUEST });
    const { data } = await api.get("/subagent/" + id);

    var dt = data.Result;
    if (typeof dt == "string") {
      dispatch({
        type: SUB_AGENT_GET_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: SUB_AGENT_GET_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: SUB_AGENT_GET_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateSubAgent = (id, parm) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUB_AGENT_UPDATE_REQUEST });
    const { data } = await api.put("/subagent/" + id, parm);

    var dt = data.Result;
    if (dt.includes("Error")) {
      dispatch({
        type: SUB_AGENT_UPDATE_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: SUB_AGENT_UPDATE_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: SUB_AGENT_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
